import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { styles } from '../view/styles';
import { WEB_COMPONENT_EASM_TOP_OPEN_PORTS } from '../../../../webcomponents.constants';
import { GzEasmGenericTopDataWebComponent } from '../../genericTopData';
import { query, property, customElement } from 'lit/decorators.js';
import { handleWidgetWithTopDataResize } from '../../../utils/utils';
import { translateFn } from '../../../../utils/translator.helper';
import { FilterType } from '../../genericTopData/types/types';
import { FindingClassType } from '../../../types';
import { MIN_NUMBER_OF_ROWS_TO_DISPLAY } from '../../constants';

@customElement(WEB_COMPONENT_EASM_TOP_OPEN_PORTS)
export class GzEasmOpenPortsWebComponent extends GzGenericWidgetContent {
  @property({
    type: WidgetStateFrontEnd,
    attribute: true,
    reflect: true,
  })
  state: WidgetStateFrontEnd;

  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: any;

  // This is used for widget resize handle
  @query('gz-easm-generic-top-data')
  private gzEASMGenericTopData: GzEasmGenericTopDataWebComponent;

  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  protected renderContent(): TemplateResult {
    const numberOfObjectsDisplayed = this.payload?.openPorts?.rowsData
      ? Object.keys(this.payload?.openPorts?.rowsData).length
      : 0;
    const totalAssets = this.payload?.openPorts?.total;

    const textButton =
      totalAssets > 0
        ? translateFn('View all ({totalAssets})', {
            totalAssets,
          })
        : null;
    return html`
      <gz-easm-generic-top-data
        .rowsData=${this.payload?.openPorts?.rowsData ?? []}
        .numberOfRowsToDisplay=${numberOfObjectsDisplayed}
        .minNumberOfRowsToDisplay=${MIN_NUMBER_OF_ROWS_TO_DISPLAY}
        .numberOfRowsAvailable=${numberOfObjectsDisplayed}
        .buttonText=${textButton}
        .navigateToSmartViewId=${this.payload?.inventorySmartViewId}
        .filterType="${FilterType.PORT}"
        .findingType="${FindingClassType.ARTIFACT}"
      >
      </gz-easm-generic-top-data>
    `;
  }

  protected handleResize(): void {
    super.handleResize();
    handleWidgetWithTopDataResize.call(this);
  }
}
